var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer, useState } from "react";
import JetDialogModal from "../../../Jetstream/DialogModal";
import JetSecondaryButton from "../../../Jetstream/SecondaryButton";
import axios from "axios";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import { CheckIcon } from "@heroicons/react/24/solid";
import _ from "lodash";
import PaginationCallbacks from "../../../Jetstream/PaginationCallbacks";
import { router } from '@inertiajs/react';
import Loader from "@/Jetstream/Loader";
export default function BranchMembers(_a) {
    var team = _a.team, currentlyManagingMembers = _a.currentlyManagingMembers, setCurrentlyManagingMembers = _a.setCurrentlyManagingMembers, user = _a.user;
    var route = useRoute(Ziggy);
    var _b = useState(""), search = _b[0], setSearch = _b[1];
    var _c = useState(null), branches = _c[0], setBranches = _c[1];
    var _d = useState(""), branchesUrl = _d[0], setBranchesUrl = _d[1];
    var _e = useReducer(function (x) { return x + 1; }, 0), ignored = _e[0], forceUpdate = _e[1];
    var _f = useState(false), loading = _f[0], setLoading = _f[1];
    // const branchesForm = useForm(null);
    function doSearch(keyword) {
        setSearch(keyword);
        var url = new URL(branchesUrl);
        url.searchParams.set('search', keyword);
        setBranchesUrl(url.toString());
        loadBranches(url.toString());
    }
    useEffect(function () {
        loadBranches();
    }, []);
    useEffect(function () {
        if (currentlyManagingMembers === false) {
            router.reload({ preserveScroll: true });
        }
    }, [currentlyManagingMembers]);
    function loadBranches(url) {
        if (url === void 0) { url = route('team.branch.index', { team: team, user_id: user.id }); }
        setBranchesUrl(url);
        setLoading(true);
        axios.get(url).then(function (resp) {
            resp.data.data.map(function (branch) {
                branch.$selected = _.find(user.branches, { id: branch.id });
            });
            setBranches(resp.data);
            console.log("Set branches", resp.data);
            // branchesForm.setData(resp.data.data);
            setLoading(false);
        }, function () {
            alert("Unexpected error");
            setLoading(false);
        });
    }
    function onPageChange(url) {
        loadBranches(url);
    }
    function toggleBranch(branch) {
        console.log('toggleUser', branch);
        branch.$selected = !branch.$selected;
        // branchesForm.setData(branchesForm.data);
        if (branch.$selected) {
            user.branches.push(branch);
        }
        else {
            _.remove(user.branches, { id: branch.id });
        }
        forceUpdate();
        axios.post(route('team.branch.membership', { team: team, branch: branch }), { user_id: user.id, member: branch.$selected }).then(function (resp) {
        }, function () {
            alert("Unexpected error");
        });
    }
    return _jsxs(JetDialogModal, __assign({ isOpen: currentlyManagingMembers, onClose: function () { return setCurrentlyManagingMembers(false); } }, { children: [_jsx(JetDialogModal.Content, { title: "Manage Branches for ".concat(user.name) }), user ? (_jsx("div", { children: _jsxs("div", __assign({ className: "relative z-0 mt-1 border border-gray-200 rounded-lg cursor-pointer" }, { children: [branches && _jsxs("table", __assign({ className: "min-w-full" }, { children: [_jsx("thead", __assign({ className: "bg-gray-50" }, { children: _jsxs("tr", { children: [_jsx("th", __assign({ scope: "col", className: "w-1/2 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, { children: "Name" })), _jsx("th", __assign({ scope: "col", className: "relative px-6 py-3" }, { children: _jsx("div", __assign({ className: "lg:flex items-center justify-end" }, { children: _jsx("input", { type: "search", id: "search", placeholder: "Search...", value: search, onChange: function (e) { return doSearch(e.target.value); }, className: ' border-gray-300 focus:border-sky-300 focus:ring focus:ring-sky-200 focus:ring-opacity-50 rounded-full shadow-sm mr-4' }) })) }))] }) })), _jsxs("tbody", { children: [loading && _jsx("tr", { children: _jsx("td", __assign({ colSpan: 2, className: "" }, { children: _jsx("div", __assign({ className: "flex items-center justify-center p-20" }, { children: _jsx(Loader, {}) })) })) }), !loading && branches.data && branches.data.map(function (branch) { return _jsxs("tr", __assign({ id: "branch-".concat(branch.id), className: "border-b ".concat(branch.$selected ? 'bg-sky-100 border-sky-200' : '', " hover:bg-sky-50"), onClick: function () { return toggleBranch(branch); } }, { children: [_jsx("td", __assign({ className: "w-1/2 px-6 py-3 text-left" }, { children: branch.name })), _jsx("td", __assign({ className: "px-6 py-3 text-left" }, { children: branch.$selected && _jsx(CheckIcon, { className: "w-6 h-6 text-sky-600" }) }))] }), branch.id); })] })] })), branches && _jsx("div", __assign({ className: "flex" }, { children: branches.last_page > 1 && _jsx(PaginationCallbacks, { pagination: branches, onChange: function (url) { return onPageChange(url); } }) }))] })) })) : null, _jsx(JetDialogModal.Footer, { children: _jsx(JetSecondaryButton, __assign({ id: "save", onClick: function () { setCurrentlyManagingMembers(false); } }, { children: "Save" })) })] }));
}
